import { useState } from 'react';
import styles from "../styles/mobileRow.module.css";

function AddItemRow(props) {
  // ---------------------------------------------------------------- state and hooks

  const [name, setName] = useState('');
  const [details, setDetails] = useState('');

  // ---------------------------------------------------------------- render
  if (window.screen.width > 500) {
    return (
      <tr>
        <td style={{ width: '30%' }}>
          <input
            style={{ width: 'calc(100% - 10px)', marginLeft: '0px' }}
            maxLength={50}
            value={name}
            onChange={(event) => setName(event.target.value)}
          />
        </td>

        <td style={{ width: '60%' }}>
          <textarea
            style={{ width: 'calc(100% - 10px)' }}
            value={details}
            onChange={(event) => setDetails(event.target.value)}
            rows={10}
          />
        </td>
        <td style={{ width: '10%', textAlign: 'left' }}>
          <div>
            <button
              style={{ marginBottom: '10px' }}
              disabled={!name}
              onClick={() => props.addItemHandler(name, details)}>
              Save
            </button>
          </div>
          <div>
            <button onClick={props.cancelAddItemHandler}>Cancel</button>
          </div>
        </td>
      </tr>
    );
  } else {
    return (
      <div className={styles.container}>
        <input
          style={{ width: 'calc(100% - 10px)', marginLeft: '0px' }}
          maxLength={50}
          value={name}
          placeholder='Item'
          onChange={(event) => setName(event.target.value)}
          className={styles.titleInput}
        />

        <textarea
          style={{ width: 'calc(100% - 10px)' }}
          value={details}
          placeholder='Details'
          onChange={(event) => setDetails(event.target.value)}
          rows={10}
          className={styles.detailsInput}
        />

        <div className={styles.buttons}>
          <button
            className={styles.actionButton}
            disabled={!name}
            onClick={() => props.addItemHandler(name, details)}>
            Save
          </button>

          <button onClick={props.cancelAddItemHandler} className={styles.actionButton}>Cancel</button>
        </div>
      </div>
    )
  }
}

export default AddItemRow;
